var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React from "react";
import { LockIcon } from "@riseart/icons";
import { Button } from "@riseart/common";
import { CartSummaryList, CartSummaryListRow, CartSummaryListRowLine } from "./List";
import { CartSummarySubtotal } from "./Subtotal";
import { CartSummaryShipping } from "./Shipping";
import { CartSummaryWrapper } from "./Wrapper";
import { CartSummaryContent } from "./Content";
import { cartSummaryListRowHintCls, cartSummaryActionCls, cartSummaryActionHintCls, cartSummaryButtonWrapperCls } from "./Summary.less";
var DEFAULT_CONFIG = {
  canEditShipping: true,
  canEditCoupon: true,
  canEditCredit: true,
  canApplyGiftCard: true,
  showActionButton: true
};
function CartSummary(_ref) {
  var children = _ref.children, _ref$config = _ref.config, config = _ref$config === void 0 ? DEFAULT_CONFIG : _ref$config, isShippingFree = _ref.isShippingFree, hasShipping = _ref.hasShipping, hasDiscount = _ref.hasDiscount, isCreditApplied = _ref.isCreditApplied, subtotalAmount = _ref.subtotalAmount, shippingAmount = _ref.shippingAmount, discountAmount = _ref.discountAmount, creditsAmount = _ref.creditsAmount, totalAmount = _ref.totalAmount, couponCode = _ref.couponCode, shippingAddress = _ref.shippingAddress, useCredit = _ref.useCredit, rental = _ref.rental, rentalPeriod = _ref.rentalPeriod, formatMessage = _ref.formatMessage, currencyFormatter = _ref.currencyFormatter, checkoutUrl = _ref.checkoutUrl, countryCodeList = _ref.countryCodeList, translations = _ref.translations, onShippingChange = _ref.onShippingChange, onDiscountAdd = _ref.onDiscountAdd, onDiscountDelete = _ref.onDiscountDelete, onCreditAdd = _ref.onCreditAdd, onCreditDelete = _ref.onCreditDelete, onGiftClick = _ref.onGiftClick;
  var mergedConfig = _objectSpread(_objectSpread({}, DEFAULT_CONFIG), config);
  return /* @__PURE__ */ React.createElement(CartSummaryWrapper, null, children ? /* @__PURE__ */ React.createElement(CartSummaryContent, null, children) : null, /* @__PURE__ */ React.createElement(CartSummaryList, null, /* @__PURE__ */ React.createElement(CartSummaryListRow, null, /* @__PURE__ */ React.createElement(CartSummaryListRowLine, {
    label: translations.subtotal
  }, currencyFormatter(subtotalAmount), rental && rentalPeriod ? "/".concat(rentalPeriod) : null)), hasShipping ? /* @__PURE__ */ React.createElement(CartSummaryListRow, null, /* @__PURE__ */ React.createElement(CartSummaryShipping, {
    translations,
    onShippingChange,
    formatMessage,
    countryCodeList,
    currentShippingCountryCode: shippingAddress.countryCode,
    canEditShipping: mergedConfig.canEditShipping,
    isShippingFree,
    shippingAmount,
    currencyFormatter
  })) : null, hasDiscount ? /* @__PURE__ */ React.createElement(CartSummaryListRow, null, /* @__PURE__ */ React.createElement(CartSummaryListRowLine, {
    label: translations.discount
  }, currencyFormatter(discountAmount)), mergedConfig.canEditCoupon && couponCode ? /* @__PURE__ */ React.createElement("span", {
    className: cartSummaryListRowHintCls
  }, translations.usingCouponCode, " ", /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    onClick: onDiscountDelete
  }, "- ", translations.remove)) : null) : null, isCreditApplied ? /* @__PURE__ */ React.createElement(CartSummaryListRow, null, /* @__PURE__ */ React.createElement(CartSummaryListRowLine, {
    label: /* @__PURE__ */ React.createElement(React.Fragment, null, translations.credit, mergedConfig.canEditCredit ? /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement(Button, {
      type: "link",
      onClick: onCreditDelete
    }, "- ", translations.remove)) : null)
  }, currencyFormatter(creditsAmount))) : null), /* @__PURE__ */ React.createElement(CartSummarySubtotal, {
    label: translations.total
  }, currencyFormatter(totalAmount)), mergedConfig.showActionButton ? /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryActionCls
  }, /* @__PURE__ */ React.createElement(Button, {
    isAnchor: true,
    to: checkoutUrl,
    width: "container",
    size: "medium",
    icon: /* @__PURE__ */ React.createElement(LockIcon, null)
  }, /* @__PURE__ */ React.createElement(LockIcon, null), " ", translations.checkoutBtnLabel)) : null, !hasDiscount && mergedConfig.canEditCoupon || !useCredit && mergedConfig.canEditCredit || mergedConfig.canApplyGiftCard ? /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryButtonWrapperCls
  }, /* @__PURE__ */ React.createElement("span", null, "+ ", translations.apply), !hasDiscount && mergedConfig.canEditCoupon ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    onClick: onDiscountAdd
  }, translations.discount), !useCredit && mergedConfig.canEditCredit || mergedConfig.canApplyGiftCard ? "|" : null) : null, !useCredit && mergedConfig.canEditCredit ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    onClick: onCreditAdd
  }, translations.credit), mergedConfig.canApplyGiftCard ? "|" : null) : null, mergedConfig.canApplyGiftCard ? /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    onClick: onGiftClick
  }, translations.giftCard) : null) : null, rental && (useCredit || hasDiscount) ? /* @__PURE__ */ React.createElement("div", {
    className: cartSummaryActionHintCls
  }, translations.rentalCreditNote) : null);
}
__name(CartSummary, "CartSummary");
export {
  CartSummary
};
